import { type ReactNode } from 'react';
import AppNav from '../AppNav';

interface CommunityLayoutProps {
  children: ReactNode;
}

export default function CommunityLayout({ children }: CommunityLayoutProps) {
  return (
    <div
      className="h-[100dvh] overflow-hidden flex flex-col bg-gradient-to-b from-orange-50 to-white dark:from-gray-900 dark:to-gray-900"
    >
      <AppNav />

      {children}
    </div>
  );
}
